<template>
    <div class="imgUpload">
        <div class="img" v-for="(item, index) in imgArr" :key="index" v-if="imgArr.length">
            <div class="shade" ref="shade">
                <i class="el-icon-delete" @click="onDel(index)" style="font-size:24px"></i>
                <i class="el-icon-zoom-in" @click="onPreview(index)" style="font-size:24px"></i>
            </div>
            <div class="img_hover" ref="img_hover">
                <el-image class="upload_img" v-if="imgArr.length" :preview-src-list="imgArr" :z-index="999999" ref="upload_img" :src="item" alt=""></el-image>
            </div>
        </div>
        <input type="file" accept="image/*" ref="img_file" @change="getFile" id="file" style="display:none" value="" multiple />
        <i v-if="imgArr.length < imgLength" class="el-icon-plus avatar-uploader-icon" @click="onUpload"></i>

        <!-- <div class="block">
            <el-image-viewer v-if="showViewer" v-for="(url, index) in imgArr" :on-close="closeViewer" :url-list="getSrcList(index)" />
        </div> -->
    </div>
</template>
<script>
export default {
    props: {
        imageArr: { //预览的图片数组
            default: function () {
                return []
            },
            type: Array
        },
        imgLength: { // 限制上传的图片数量
            default: 1,
            type: Number
        }
    },
    computed: {
        imgArr() {
            return this.imageArr
        }
    },
    data() {
        return {
            showViewer: false,
        }
    },
    methods: {
        // 删除
        onDel(index) {
            console.log('删除')
            this.imgArr.splice(index, 1)
            console.log(this.imgArr.length, this.imgLength)
            this.$emit('success', this.imgArr)
        },
        // 预览
        onPreview(index) {
            this.$refs.upload_img[index].clickHandler()
            setTimeout(() => {
                let domImageMask = document.querySelector(".el-image-viewer__mask");
                if (!domImageMask) {
                    return;
                }
                domImageMask.addEventListener("click", () => {
                    // 点击遮罩层时调用关闭按钮的 click 事件
                    document.querySelector(".el-image-viewer__close").click();
                });
            })
        },
        onUpload() {
            this.$refs.img_file.value = "";
            this.$refs.img_file.click()
        },
        // 上传图片
        getFile(e) {
            let oFile = this.$refs.img_file; //获取input file节点
            let file = oFile.files;
            let arrFile = [...file];
            let fd = new FormData();
            fd.append('businessType', '1');
            fd.append('userId', '0');
            console.log('图片长度', this.imgArr.length + arrFile.length, this.imgLength)
            if (this.imgArr.length + arrFile.length > this.imgLength) {
                this.$message.error(`最多只能上传${this.imgLength}张`);
                return;
            }
            for (let i = 0; i < arrFile.length; i++) {  //判断图片大小尺寸（不能超过5m）和图片格式
                let item = arrFile[i]
                fd.append("multipartFiles", item);
                let imgSize = item.size / 1024 / 1024 > 10;
                if (imgSize) {
                    this.$message.error('图片大小不能超过10m');
                    return;
                }
                if (
                    item.type !== "image/jpeg" &&
                    item.type !== "image/png" &&
                    item.type !== "image/jpg"
                ) {
                    this.$message.error("图片只能上传 PNG、JPG、JPEG 格式!");
                    return;
                }
            }
            this.$https.post('system/uploadImg', fd).then(res => {
                // console.log(res);
                if (res.code == 200) {
                    this.$message.success('上传成功')
                    this.imgArr.push(...res.data);
                    console.log(this.imgArr)
                    this.$emit('success', this.imgArr)
                } else {
                    this.$message.error('上传失败');
                }
            });
        },
    }
}
</script>
<style lang="less" scoped>
.imgUpload {
  margin-bottom: 20px;
  display: flex;
  .img {
    display: flex;
    position: relative;
    width: 142px;
    height: 142px;
    border-radius: 8px;
    margin-right: 10px;
    .shade {
      position: absolute;
      background: transparent;
      display: flex;
      justify-content: space-around;
      align-items: center;
      opacity: 0.7;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 99;
      /deep/ .el-icon-delete,
      .el-icon-zoom-in {
        color: transparent !important;
      }
      // visibility: hidden;
    }
    .shade:hover {
      position: absolute;
      background: #000;
      display: flex;
      justify-content: space-around;
      align-items: center;
      // visibility: visible;
      opacity: 0.7;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      /deep/ .el-icon-delete,
      .el-icon-zoom-in {
        color: #fff !important;
      }
    }
    .img_hover {
      width: 100%;
      height: 100%;
      // margin-right: 14px;
      display: flex;
      // z-index: 9999;
      /deep/ .upload_img {
        width: 100%;
        height: 100%;
      }
    }
  }
  /deep/ .el-icon-plus {
    border: 1px dashed #d9d9d9;
    width: 142px;
    height: 142px;
    line-height: 142px;
    text-align: center;
  }
  /deep/ .el-icon-plus:hover {
    border-color: #409eff;
  }
}
</style>
